import React from "react";

export const ACCENT = "#1b4d2e";

export const MONTHS_ES = [
  "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
  "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre",
];

export const MONTHS_SHORT = [
  "Ene", "Feb", "Mar", "Abr", "May", "Jun",
  "Jul", "Ago", "Sep", "Oct", "Nov", "Dic",
];

export const PIE_COLORS = [ACCENT, "#3B82F6", "#F59E0B", "#8B5CF6", "#EC4899", "#6366F1", "#14B8A6", "#F97316"];

export const formatMXN = (v) => {
  const n = Number(v || 0);
  return n < 0 ? `-$${Math.abs(n).toLocaleString("es-MX")}` : `$${n.toLocaleString("es-MX")}`;
};

export const defaultMonth = () => {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
};

export const Section = ({ icon: Icon, title, children, className = "", action }) => (
  <div
    className={`rounded-xl border border-zinc-200 dark:border-zinc-700/60 bg-white dark:bg-zinc-800/50 p-5 shadow-sm ${className}`}
  >
    <div className="flex items-center gap-2 mb-4">
      <div
        className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg"
        style={{ backgroundColor: ACCENT + "1a" }}
      >
        <Icon className="h-4 w-4" style={{ color: ACCENT }} />
      </div>
      <span className="text-sm font-semibold uppercase tracking-wide text-zinc-500 dark:text-zinc-400">
        {title}
      </span>
      {action && <div className="ml-auto">{action}</div>}
    </div>
    {children}
  </div>
);

export const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="rounded-lg border border-zinc-200 dark:border-zinc-700 bg-white dark:bg-zinc-800 p-3 shadow-lg text-sm">
      <div className="font-semibold text-zinc-900 dark:text-white mb-1">{label}</div>
      {payload.map((entry) => (
        <div key={entry.dataKey} className="flex items-center gap-2">
          <div className="h-2.5 w-2.5 rounded-full" style={{ backgroundColor: entry.color }} />
          <span className="text-zinc-500">{entry.name}:</span>
          <span className="font-medium" style={{ color: entry.color }}>
            {formatMXN(entry.value)}
          </span>
        </div>
      ))}
    </div>
  );
};
